import {Component, Input} from '@angular/core';

/**
 * Explanation of the roles as a grid of cards; the roles in `selected` (role keys) are highlighted.
 * Display only: the roles are chosen in the select above it.
 */
@Component({
    selector: 'app-user-role-descriptions',
    templateUrl: './user-role-descriptions.component.html',
    styleUrl: './user-role-descriptions.component.scss'
})
export class UserRoleDescriptionsComponent {
    @Input() roles: any[] = [];
    @Input() selected: string[] | null = [];
}
